// removed by extract-text-webpack-plugin
module.exports = {"nav":"kk_h8 _2Xrz7I_QTrHvmZWakDFK7Y _3WCCq13R86ci-P4gMMM_yg _1q4KCwzH_bfCuMBpkmmQmA","list":"kk_ce _3JIEYde9anI6O5H5wYv2ik","item":"kk_fl","link":"kk_cx","itemHideMD":"kk_kl kk_fl","transparentLink":"kk_km kk_cx","close":"kk_gt _1kB_d9laDuyaX1azPOvneD","user":"kk_kn xAqopkkdOGGGoJ5WQXWb7 _1L6YSXzlhVcylGdqFzi4Fw","transparentUser":"kk_ko kk_kn xAqopkkdOGGGoJ5WQXWb7 _1L6YSXzlhVcylGdqFzi4Fw","search":"kk_be kk_fl","searchLink":"kk_kp kk_cx","transparentSearchLink":"kk_kq kk_km kk_cx"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/HeaderMenu/components/HeaderMenuNav/styles.module.css
// module id = 1089
// module chunks = 27